// import locationView from "./views/locationView.js";
import cloudyDay01Icon from "../icons/amcharts_weather_icons_1.0.0/animated/cloudy-day-1.svg";
import cloudyDay02Icon from "../icons/amcharts_weather_icons_1.0.0/animated/cloudy-day-2.svg";
import cloudyDay03Icon from "../icons/amcharts_weather_icons_1.0.0/animated/cloudy-day-3.svg";
import cloudyNight01Icon from "../icons/amcharts_weather_icons_1.0.0/animated/cloudy-night-1.svg";
import cloudyNight02Icon from "../icons/amcharts_weather_icons_1.0.0/animated/cloudy-night-2.svg";
import cloudyNight03Icon from "../icons/amcharts_weather_icons_1.0.0/animated/cloudy-night-3.svg";
import cloudyIcon from "../icons/amcharts_weather_icons_1.0.0/animated/cloudy.svg";
import dayIcon from "../icons/amcharts_weather_icons_1.0.0/animated/day.svg";
import nightIcon from "../icons/amcharts_weather_icons_1.0.0/animated/night.svg";
import rainy01Icon from "../icons/amcharts_weather_icons_1.0.0/animated/rainy-1.svg";
import rainy02Icon from "../icons/amcharts_weather_icons_1.0.0/animated/rainy-2.svg";
import rainy03Icon from "../icons/amcharts_weather_icons_1.0.0/animated/rainy-3.svg";
import rainy04Icon from "../icons/amcharts_weather_icons_1.0.0/animated/rainy-4.svg";
import rainy05Icon from "../icons/amcharts_weather_icons_1.0.0/animated/rainy-5.svg";
import rainy06Icon from "../icons/amcharts_weather_icons_1.0.0/animated/rainy-6.svg";
import rainy07Icon from "../icons/amcharts_weather_icons_1.0.0/animated/rainy-7.svg";
import snowy01Icon from "../icons/amcharts_weather_icons_1.0.0/animated/snowy-1.svg";
import snowy02Icon from "../icons/amcharts_weather_icons_1.0.0/animated/snowy-2.svg";
import snowy03Icon from "../icons/amcharts_weather_icons_1.0.0/animated/snowy-3.svg";
import snowy04Icon from "../icons/amcharts_weather_icons_1.0.0/animated/snowy-4.svg";
import snowy05Icon from "../icons/amcharts_weather_icons_1.0.0/animated/snowy-5.svg";
import snowy06Icon from "../icons/amcharts_weather_icons_1.0.0/animated/snowy-6.svg";
import placeHolderImg from "../image/clouds-placeholder.webp";
import thunderIcon from "../icons/amcharts_weather_icons_1.0.0/animated/thunder.svg";
import _ from "lodash";

export const state = {
  dataLoaded: false,
  loading: false,
  timeout: 0,
  searchIcon: "search",
  tempUnit: "celcius",
  data: {},
  weatherData: {},
  day: 0,
  bookmarks: [],
};

let map;

export async function initPlaces(placeId = "ChIJc3FBGy2UcEgRmHnurvD-gco") {
  try {
    let { Place } = await google.maps.importLibrary("places");
    map = await new google.maps.Map(document.getElementById("map"), {});

    let request = {
      placeId: placeId,
      fields: [
        "name",
        "formatted_address",
        "geometry",
        "photos",
        "place_id",
        "utc_offset_minutes",
      ],
    };

    const service = await new google.maps.places.PlacesService(map);
    const getPlaceById = async function (place, status) {
      if (status == google.maps.places.PlacesServiceStatus.OK) {
        state.dataLoaded = false;
        await createState(place);

        state.data.checkPhotosExist();
        state.data.getPlaceTimeUTC();

        state.weatherData.tempUnit = "celcius";
        await fetchWeather();
        const addLoadEvent = async function () {
          let event = new Event("State_Loaded");
          window.dispatchEvent(event);
        };
        await addLoadEvent();
      }
    };
    await service.getDetails(request, getPlaceById);
  } catch (err) {
    console.err(err);
    throw err;
  }
}

export let autocomplete;

export async function initAutocomplete() {
  try {
    let { Place } = await google.maps.importLibrary("places");

    autocomplete = new google.maps.places.Autocomplete(state.searchBar, {
      types: ["(regions)"],
      fields: [
        "name",
        "formatted_address",
        "geometry",
        "photos",
        "place_id",
        "utc_offset_minutes",
      ],
    });
  } catch (err) {
    console.error(err);
    alert("Google Service Error, please try again");
  }
}

export async function onPlaceClick() {
  try {
    place = autocomplete.getPlace();
    console.log(place);
    if (!place.geometry) {
      //User did not select a prediction
      state.searchBar.placeholder = "Please select a location";
    } else {
      // locationImgContainer.classList.add("skeleton")
      await createState(place);

      state.data.checkPhotosExist();
      state.data.getPlaceTimeUTC();

      state.weatherData.tempUnit = "celcius";
      await fetchWeather();
    }
  } catch (err) {
    console.error(err);
  }
}

export const createState = async function (place) {
  state.dataLoaded = false;
  state.loading = true;
  state.data = place;
  state.data = {
    placeName: state.data.name,
    formattedAddress: state.data.formatted_address,
    latitude: state.data.geometry.location.lat(),
    longitude: state.data.geometry.location.lng(),
    photos: state.data?.photos,
    photosLandscape: [],
    photosPortrait: [],
    photoPlaceholder: [],

    placeId: state.data.place_id,
    utcOffsetMinutes: state.data.utc_offset_minutes,

    getLandscapeImgArr() {
      if (!this.photos[0] || !this.photos) {
        return;
      } else {
        this.photos.forEach((photo) => {
          if (
            photo.width > photo.height &&
            photo.width < photo.height + photo.height //Ensures a good aspect ratio for the image
          ) {
            this.photosLandscape.push(photo);
          }
        });
      }
    },
    getPortraitImgArr() {
      if (!this.photos[0] || !this.photos) {
        return;
      } else {
        this.photos.forEach((photo) => {
          if (photo.width < photo.height) {
            this.photosPortrait.push(photo);
          }
        });
      }
    },
    checkPhotosExist() {
      if (state.data.photos) {
        state.data.getLandscapeImgArr();
        state.data.getPortraitImgArr();
      } else {
        return;
      }
    },

    getPlaceTimeUTC() {
      let currentTime = new Date();

      let currentTimeMillis = currentTime.getTime();

      let hoursMillis = this.utcOffsetMinutes * 60000; // get the utc offset in milliseconds.
      currentTimeMillis = currentTimeMillis + hoursMillis;

      let placeTime = new Date(currentTimeMillis);

      this.year = placeTime.getFullYear();
      this.monthLong = placeTime.toLocaleString("default", {
        month: "long",
      });
      let realPlaceTime = placeTime.getMonth() + 1;

      //Adds zero infront of num less than 10
      if (realPlaceTime < 10) {
        this.monthNum = "0" + realPlaceTime;
      } else {
        this.monthNum = realPlaceTime;
      }
      this.day = placeTime.toLocaleString("default", { weekday: "long" });

      //Adds zero infront of num less than 10 ->>>
      if (placeTime.getDate() < 10) {
        this.date = "0" + placeTime.getDate();
      } else {
        this.date = placeTime.getDate();
      }

      if (placeTime.getHours() < 10) {
        this.hour = "0" + placeTime.getHours();
      } else {
        this.hour = placeTime.getHours();
      }

      if (placeTime.getMinutes() < 10) {
        this.minute = "0" + placeTime.getMinutes();
      } else {
        this.minute = placeTime.getMinutes();
      }

      return placeTime;
    },

    returnImg() {
      //First prioritizes landscape photos then portrait, then placeholder
      if (this.photosLandscape[0]) {
        return this.photosLandscape[0].getUrl();
      }
      if (this.photosPortrait[0]) {
        return this.photosPortrait[0].getUrl();
      } else {
        return placeHolderImg;
      }
    },

    returnContributor() {
      //First prioritizes landscape photos then portrait, then placeholder
      if (this.photosLandscape[0]) {
        return this.photosLandscape[0].html_attributions[0];
      }
      if (this.photosPortrait[0]) {
        return this.photosPortrait[0].html_attributions[0];
      } else {
        return "Live image unavailable";
      }
    },
  };
};

const fetchWeather = async function () {
  try {
    const weatherRes = await fetch(
      `https://api.open-meteo.com/v1/forecast?latitude=${state.data.latitude}&longitude=${state.data.longitude}&current=temperature_2m,relative_humidity_2m,apparent_temperature,is_day,precipitation,rain,showers,snowfall,weather_code,cloud_cover,wind_speed_10m,wind_direction_10m&hourly=temperature_2m,relative_humidity_2m,dew_point_2m,apparent_temperature,precipitation_probability,precipitation,rain,showers,snowfall,snow_depth,weather_code,cloud_cover,visibility,wind_speed_10m&daily=weather_code,temperature_2m_max,temperature_2m_min,sunrise,sunset,precipitation_sum,rain_sum,showers_sum,snowfall_sum,precipitation_hours&forecast_days=14`
    );

    const weatherDataOriginal = await weatherRes.json();
    if (!weatherRes.ok)
      throw new Error(
        `${weatherRes.status}, Something went wrong, please try again.`
      );

    state.weatherData = {
      //
      current: {
        apparantTemperature: weatherDataOriginal.current.apparent_temperature,
        apparantTemperatureUnit:
          weatherDataOriginal.current_units.apparent_temperature,
        apparantTemperatureFarenheight: convertTemp(
          weatherDataOriginal.current.apparent_temperature
        ),
        apparantTemperatureFarenheightUnit: "°F",
        cloudCover: weatherDataOriginal.current.cloud_cover,
        cloudCoverUnit: weatherDataOriginal.current_units.cloud_cover,
        interval: weatherDataOriginal.current.interval,
        intervalUnit: weatherDataOriginal.current_units.interval,
        isDay: weatherDataOriginal.current.is_day,
        precipitation: weatherDataOriginal.current.precipitation,
        precipitationUnit: weatherDataOriginal.current_units.precipitation,
        rain: weatherDataOriginal.current.rain,
        rainUnit: weatherDataOriginal.current_units.rain,
        relativeHumidity: weatherDataOriginal.current.relative_humidity_2m,
        relativeHumidityUnit:
          weatherDataOriginal.current_units.relative_humidity_2m,
        showers: weatherDataOriginal.current.showers,
        showersUnit: weatherDataOriginal.current_units.showers,
        snowfall: weatherDataOriginal.current.snowfall,
        snowfallUnit: weatherDataOriginal.current_units.snowfall,
        temperature: weatherDataOriginal.current.temperature_2m,
        temperatureUnit: weatherDataOriginal.current_units.temperature_2m,
        temperatureFarenheight: convertTemp(
          weatherDataOriginal.current.temperature_2m
        ),
        temperatureFarenheightUnit: "°F",
        timeISO: weatherDataOriginal.current.weather_code,
        windDirection: weatherDataOriginal.current.wind_direction_10m,
        windDirectionUnit: weatherDataOriginal.current_units.wind_direction_10m,
        windSpeed: weatherDataOriginal.current.wind_speed_10m,
        windSpeedUnit: weatherDataOriginal.current_units.wind_speed_10m,
        precipitationProbabilty:
          weatherDataOriginal.hourly.precipitation_probability[0],
        precipitationProbabiltyUnit:
          weatherDataOriginal.hourly_units.precipitation_probability,
        weatherCode: weatherDataOriginal.current.weather_code,
        icon: getWeatherIconNew(
          weatherDataOriginal.current.is_day,
          weatherDataOriginal.current.weather_code,
          weatherDataOriginal.current.cloud_cover
        ).icon,
        description: getWeatherIconNew(
          weatherDataOriginal.current.is_day,
          weatherDataOriginal.current.weather_code,
          weatherDataOriginal.current.cloud_cover
        ).description,
      },
      daily: {
        date: weatherDataOriginal.daily.time,
        weatherCode: weatherDataOriginal.daily.weather_code,
        tempMin: weatherDataOriginal.daily.temperature_2m_min,
        tempMax: weatherDataOriginal.daily.temperature_2m_max,
        dailyGroup: [],
      },
      hourly: {
        timeRaw: weatherDataOriginal.hourly.time,
        weatherCodeRaw: weatherDataOriginal.hourly.weather_code,
        tempRaw: weatherDataOriginal.hourly.temperature_2m,
        cloudCoverRaw: weatherDataOriginal.hourly.cloud_cover,
        hourlyGroup: [],
      },

      createHourlyArray() {
        let i = -1;

        state.weatherData.hourly.timeRaw.forEach((el) => {
          i++;
          state.weatherData.hourly.hourlyGroup.push({
            time: `${new Date(state.weatherData.hourly.timeRaw[i])
              .getHours()
              .toString()
              .padStart(2, "0")}:00`,
            weatherCode: state.weatherData.hourly.weatherCodeRaw[i],
            temp: state.weatherData.hourly.tempRaw[i],
            tempF: convertTemp(state.weatherData.hourly.tempRaw[i]),
            cloudCover: state.weatherData.hourly.cloudCoverRaw[i],
            isDay: checkIfDay(state.weatherData.hourly.timeRaw[i]),
            weatherIcon: getWeatherIconNew(
              checkIfDay(state.weatherData.hourly.timeRaw[i]),
              state.weatherData.hourly.weatherCodeRaw[i],
              state.weatherData.hourly.cloudCoverRaw[i]
            ).icon,
            weatherDescription: getWeatherIconNew(
              checkIfDay(state.weatherData.hourly.timeRaw[i]),
              state.weatherData.hourly.weatherCodeRaw[i],
              state.weatherData.hourly.cloudCoverRaw[i]
            ).description,
          });
        });
        state.weatherData.hourly.hourlyGroup = split24Hours(
          state.weatherData.hourly.hourlyGroup
        );
      },

      formatDailyObject() {
        let i = -1;

        state.weatherData.daily.date.forEach((date) => {
          i++;

          state.weatherData.daily.dailyGroup.push({
            date: state.weatherData.daily.date[i],
            day: returnDay(state.weatherData.daily.date[i]),
            weatherCode: state.weatherData.daily.weatherCode[i],
            tempMin: state.weatherData.daily.tempMin[i],
            tempMax: state.weatherData.daily.tempMax[i],
            tempMinF: convertTemp(state.weatherData.daily.tempMin[i]),
            tempMaxF: convertTemp(state.weatherData.daily.tempMax[i]),
            icon: getWeatherIconNew(
              true, // We want the day time icons when showing daily weather
              state.weatherData.daily.weatherCode[i],
              state.weatherData.current.cloudCover
            ).icon,
            description: getWeatherIconNew(
              checkIfDay(state.weatherData.current.isDay),
              state.weatherData.daily.weatherCode[i],
              state.weatherData.current.cloudCover
            ).description,
            hourly: state.weatherData.hourly.hourlyGroup[i],
          });
        });
      },
    };

    // state.weatherData.getWeatherIcon();
    state.weatherData.createHourlyArray();
    state.weatherData.formatDailyObject();

    state.dataLoaded = true;
  } catch (err) {
    console.error(err);
    alert(err);
    throw err;
  }
};

const convertTemp = function (tempC) {
  let temp = tempC * 1.8 + 32;
  return Number(temp.toFixed(1));
};

const returnDay = function (dateInput) {
  let day = new Date(dateInput);
  day = day.toString().slice(0, 3);

  return day;
};

const split24Hours = function (arr) {
  return _.chunk(arr, 24);
};

const checkIfDay = function (date) {
  const hours = new Date(date).getHours();
  const isDayTime = hours > 6 && hours < 20;
  // console.log(hours, isDayTime);
  return isDayTime;
};

//////NEW ONE

const getWeatherIconNew = function (isDay, weatherCode, cloudCover) {
  //Day
  if (isDay) {
    if (weatherCode === 0) {
      return {
        icon: dayIcon,
        description: "Clear Sky",
      };
    }
    if (weatherCode === 1) {
      return {
        icon: cloudyDay01Icon,
        description: "Mainly Clear",
      };
    }
    if (weatherCode === 2) {
      return {
        icon: cloudyDay02Icon,
        description: "Partly Cloudy",
      };
    }
    if (weatherCode === 2 && cloudCover > 80) {
      return {
        icon: cloudyDay03Icon,
        description: "Mostly Cloudy",
      };
    }
    if (weatherCode === 3) {
      return {
        icon: cloudyIcon,
        description: "Overcast",
      };
    }
    if (weatherCode === 45) {
      return {
        icon: cloudyIcon,
        description: "Fog",
      };
    }
    if (weatherCode === 48) {
      return {
        icon: cloudyIcon,
        description: "Rime Fog",
      };
    }
    if (weatherCode === 51) {
      return {
        icon: rainy02Icon,
        description: "Light Drizzle",
      };
    }
    if (weatherCode === 53) {
      return {
        icon: rainy01Icon,
        description: "Moderate Drizzle",
      };
    }
    if (weatherCode === 55) {
      return {
        icon: rainy03Icon,
        description: "Dense Drizzle",
      };
    }
    if (weatherCode === 56) {
      return {
        icon: rainy07Icon,
        description: "Freezing Light Drizzle",
      };
    }
    if (weatherCode === 57) {
      return {
        icon: rainy07Icon,
        description: "Freezing Dense Drizzle",
      };
    }
    if (weatherCode === 61) {
      return {
        icon: rainy04Icon,
        description: "Light Rain",
      };
    }
    if (weatherCode === 63) {
      return {
        icon: rainy05Icon,
        description: "Moderate Rain",
      };
    }
    if (weatherCode === 65) {
      return {
        icon: rainy06Icon,
        description: "Heavy Rain",
      };
    }
    if (weatherCode === 66) {
      return {
        icon: rainy07Icon,
        description: "Light Freezing Rain",
      };
    }
    if (weatherCode === 67) {
      return {
        icon: rainy07Icon,
        description: "Heavy Freezing Rain",
      };
    }
    if (weatherCode === 71) {
      return {
        icon: snowy04Icon,
        description: "Light Snow",
      };
    }
    if (weatherCode === 73) {
      return {
        icon: snowy05Icon,
        description: "Moderate Snow",
      };
    }
    if (weatherCode === 75) {
      return {
        icon: snowy06Icon,
        description: "Heavy Snow",
      };
    }
    if (weatherCode === 77) {
      return {
        icon: snowy06Icon,
        description: "Heavy Snow",
      };
    }
    if (weatherCode === 80) {
      return {
        icon: rainy02Icon,
        description: "Light Rain Showers",
      };
    }
    if (weatherCode === 81) {
      return {
        icon: rainy01Icon,
        description: "Moderate Rain Showers",
      };
    }
    if (weatherCode === 82) {
      return {
        icon: rainy03Icon,
        description: "Heavy rain Showers",
      };
    }
    if (weatherCode === 85) {
      return {
        icon: snowy02Icon,
        description: "Light Snow Showers",
      };
    }
    if (weatherCode === 86) {
      return {
        icon: snowy03Icon,
        description: "Heavy Snow Showers",
      };
    }
    if (weatherCode === 95) {
      return {
        icon: thunderIcon,
        description: "Thunderstorm",
      };
    }
    if (weatherCode === 96) {
      return {
        icon: thunderIcon,
        description: "Thunderstorm with Light Hail",
      };
    }
    if (weatherCode === 99) {
      return {
        icon: thunderIcon,
        description: "Thunderstorm with Heavy Hail",
      };
    }
  }

  //Night **************************************
  //******************************************** */

  if (!isDay) {
    if (weatherCode === 0) {
      return {
        icon: nightIcon,
        description: "Clear Sky",
      };
    }
    if (weatherCode === 1) {
      return {
        icon: cloudyNight01Icon,
        description: "Mainly Clear",
      };
    }
    if (weatherCode === 2) {
      return {
        icon: cloudyNight02Icon,
        description: "Partly Cloudy",
      };
    }
    if (weatherCode === 2 && cloudCover > 80) {
      return {
        icon: cloudyNight03Icon,
        description: "Mostly Cloudy",
      };
    }
    if (weatherCode === 3) {
      return {
        icon: cloudyIcon,
        description: "Overcast",
      };
    }
    if (weatherCode === 45) {
      return {
        icon: cloudyIcon,
        description: "Fog",
      };
    }
    if (weatherCode === 48) {
      return {
        icon: cloudyIcon,
        description: "Rime Fog",
      };
    }
    if (weatherCode === 51) {
      return {
        icon: rainy04Icon,
        description: "Light Drizzle",
      };
    }
    if (weatherCode === 53) {
      return {
        icon: rainy05Icon,
        description: "Moderate Drizzle",
      };
    }
    if (weatherCode === 55) {
      return {
        icon: rainy05Icon,
        description: "Dense Drizzle",
      };
    }
    if (weatherCode === 56) {
      return {
        icon: rainy07Icon,
        description: "Freezing Light Drizzle",
      };
    }
    if (weatherCode === 57) {
      return {
        icon: rainy07Icon,
        description: "Freezing Dense Drizzle",
      };
    }
    if (weatherCode === 61) {
      return {
        icon: rainy04Icon,
        description: "Light Rain",
      };
    }
    if (weatherCode === 63) {
      return {
        icon: rainy05Icon,
        description: "Moderate Rain",
      };
    }
    if (weatherCode === 65) {
      return {
        icon: rainy06Icon,
        description: "Heavy Rain",
      };
    }
    if (weatherCode === 66) {
      return {
        icon: rainy07Icon,
        description: "Light Freezing Rain",
      };
    }
    if (weatherCode === 67) {
      return {
        icon: rainy07Icon,
        description: "Heavy Freezing Rain",
      };
    }
    if (weatherCode === 71) {
      return {
        icon: snowy04Icon,
        description: "Light Snow",
      };
    }
    if (weatherCode === 73) {
      return {
        icon: snowy05Icon,
        description: "Moderate Snow",
      };
    }
    if (weatherCode === 75) {
      return {
        icon: snowy06Icon,
        description: "Heavy Snow",
      };
    }
    if (weatherCode === 77) {
      return {
        icon: snowy06Icon,
        description: "Heavy Snow",
      };
    }
    if (weatherCode === 80) {
      return {
        icon: rainy04Icon,
        description: "Light Rain Showers",
      };
    }
    if (weatherCode === 81) {
      return {
        icon: rainy05Icon,
        description: "Moderate Rain Showers",
      };
    }
    if (weatherCode === 82) {
      return {
        icon: rainy06Icon,
        description: "Heavy rain Showers",
      };
    }
    if (weatherCode === 85) {
      return {
        icon: snowy04Icon,
        description: "Light Snow Showers",
      };
    }
    if (weatherCode === 86) {
      return {
        icon: snowy06Icon,
        description: "Heavy Snow Showers",
      };
    }
    if (weatherCode === 95) {
      return {
        icon: thunderIcon,
        description: "Thunderstorm",
      };
    }
    if (weatherCode === 96) {
      return {
        icon: thunderIcon,
        description: "Thunderstorm with Light Hail",
      };
    }
    if (weatherCode === 99) {
      return {
        icon: thunderIcon,
        description: "Thunderstorm with Heavy Hail",
      };
    }
  }
};
